import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import ErrorBoundary from 'components/modules/ErrorBoundary';
import { decryptPhone } from 'services/api-service/center';
import { utilService } from 'services/util-service';
import { IStoreState } from 'store/modules';
import ExpiredPage from './ExpiredPage';
import LoadingPage from './LoadingPage';
import './Rescue.css';
import RescuePage from './RescuePage';

const RescueTemplate = () => {
  const { role: rawRole, room, phone } = useParams();
  const role = utilService.normalizeRole(rawRole);
  const curRoom: any = useSelector((store: IStoreState) => store.MainReducer.curRoom);
  const [loading, setLoading] = useState(true);
  const [agree, setAgree] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [duration, setDuration] = useState(false);

  useEffect(() => {
    if (curRoom && phone) {
      const fetchPhone = async () => {
        try {
          const response: any = await decryptPhone(phone);
          const decryptedPhone = response.phone;
          setPhoneNumber(decryptedPhone);
          setAgree(curRoom.phones.includes(decryptedPhone));
          setDuration(curRoom.durPhones.includes(decryptedPhone));
        } catch (e) {
          setPhoneNumber(null);
          setAgree(false);
        } finally {
          setLoading(false);
        }
      };
      fetchPhone();
    } else if (curRoom === undefined) {
      setLoading(true);
    }
  }, [curRoom, phone]);

  if (loading || curRoom === undefined || phoneNumber === null) {
    return (
      <RescueTemplateWrap>
        <LoadingPage />
      </RescueTemplateWrap>
    );
  }

  if (curRoom.isExpire) {
    return (
      <RescueTemplateWrap>
        <ExpiredPage />
      </RescueTemplateWrap>
    );
  }

  return (
    <RescueTemplateWrap>
      <ErrorBoundary label="RescuePage">
        <RescuePage
          agree={agree}
          duration={duration}
          room={room}
          role={role}
          phone={phoneNumber}
          setAgree={setAgree}
          setDuration={setDuration}
        />
      </ErrorBoundary>
    </RescueTemplateWrap>
  );
};

const RescueTemplateWrap = styled.div`
  width: 100%;
  height: 100%;
`;

export default RescueTemplate;
